__turbopack_context__.v({
  "child": "ExplainerToc-module__O7DgFW__child",
  "label": "ExplainerToc-module__O7DgFW__label",
  "leaves": "ExplainerToc-module__O7DgFW__leaves",
  "list": "ExplainerToc-module__O7DgFW__list",
  "parent": "ExplainerToc-module__O7DgFW__parent",
  "wrap": "ExplainerToc-module__O7DgFW__wrap",
});
